import React from "react";

const Logo = ({ size = "normal", className = "" }) => {
  const sizeClasses = {
    small: "w-8 h-8",
    normal: "w-12 h-12", 
    large: "w-16 h-16"
  };

  const textSizes = {
    small: "text-lg",
    normal: "text-2xl",
    large: "text-3xl"
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Logo SVG */}
      <div className={`${sizeClasses[size]} relative`}>
        <svg
          viewBox="0 0 64 64"
          className="w-full h-full"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* House Shape */}
          <path
            d="M32 8L52 24V52C52 54.2091 50.2091 56 48 56H16C13.7909 56 12 54.2091 12 52V24L32 8Z"
            fill="url(#houseGradient)"
            stroke="#2563eb"
            strokeWidth="2"
          />
          
          {/* Door */}
          <rect
            x="26"
            y="38"
            width="12"
            height="18"
            fill="#1e40af"
            rx="1"
          />
          
          {/* Windows */}
          <rect
            x="18"
            y="32"
            width="8"
            height="8"
            fill="#3b82f6"
            rx="1"
          />
          <rect
            x="38"
            y="32"
            width="8"
            height="8"
            fill="#3b82f6"
            rx="1"
          />
          
          {/* Dollar Sign Overlay */}
          <circle
            cx="48"
            cy="16"
            r="8"
            fill="url(#dollarGradient)"
            stroke="#059669"
            strokeWidth="2"
          />
          <text
            x="48"
            y="21"
            textAnchor="middle"
            className="text-white font-bold text-sm"
            fill="white"
          >
            $
          </text>
          
          {/* Gradients */}
          <defs>
            <linearGradient id="houseGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#3b82f6" />
              <stop offset="100%" stopColor="#1e40af" />
            </linearGradient>
            <linearGradient id="dollarGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#10b981" />
              <stop offset="100%" stopColor="#059669" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      
      {/* Text */}
      <div className="flex flex-col">
        <div className={`${textSizes[size]} font-bold text-blue-600`}>
          PropertySellEasy
        </div>
        <div className="text-xs text-gray-600 -mt-1">
          .com
        </div>
      </div>
    </div>
  );
};

export default Logo;